import queryString from "query-string";

export const chikiiWebUrl = "https://caijiyouxi.com";
export const chikiiWebUrlWww = "https://www.caijiyouxi.com";

export const postMessageId = "postmessage-iframe";

// 环境变量
export const isDev: boolean = process.env.NODE_ENV === "development";
export const env = process.env.enviroment;
console.log("env环境", process.env.basepath);

const envUpper = env === "dev" ? "ALPHA" : env?.toUpperCase();

const NetWorkConfig = {
  dev: {
    apiUrl: "http://api-beta.chikiigame.com:8090",
    socketUrl: "ws://s-goim-beta.chikiigame.com:8093/sub",
  },
  alpha: {
    apiUrl: "http://api-beta.chikiigame.com:8090",
    socketUrl: "wss://s-goim-beta.chikiigame.com:8093/sub",
  },
  pre: {
    apiUrl: "http://api-beta.chikiigame.com:8090",
    socketUrl: "wss://s-goim-beta.chikiigame.com:8093/sub",
  },
  release: {
    apiUrl: "https://api-prod.chikiigame.com",
    socketUrl: "wss://s-goim.chikiigame.com:8890/sub",
  },
};

// 是否pc端的跳转
export const IS_PC = Number(queryString.parse(location.search).is_pc) > 0;

const GetNetWorkConfig = () => {
  if (window.location.href.indexOf("beta.www.caiji188.com") > -1) {
    return NetWorkConfig["dev"];
  }

  if (env === "dev") {
    return NetWorkConfig["dev"];
  }

  if (env === "alpha") {
    return NetWorkConfig["alpha"];
  }

  if (env === "pre") {
    return NetWorkConfig["pre"];
  }

  if (env === "cputest") {
    return NetWorkConfig["release"];
  }

  if (isDev) {
    return NetWorkConfig["dev"];
  }

  return NetWorkConfig["release"];
};

// 環境地址
export const baseURL = GetNetWorkConfig().apiUrl;
export const websocketUrl = GetNetWorkConfig().socketUrl;
// pc端下载地址
export const downloadURL = `${baseURL}/yungame/download_client?type=1`;
// 安卓apk下载地址
export const downloadAndroid = `${baseURL}/yungame/download_client?type=2`;
// ios下载跳转链接
export const downloadIPhone =
  "https://apps.apple.com/cn/app/%E5%87%A0%E6%B8%B8/id1573551317";

// 登录回调地址
export const qqUrl = `https://graph.qq.com/oauth2.0/show?which=Login&display=pc&response_type=code&client_id=101540930&redirect_uri=https%3A%2F%2Fcb.caijiyouxi.com%2Fdy_qq_login?type=QQ_WEB_${envUpper}&scope=all`;
export const wechatUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wx6635a952b2f594af&redirect_uri=https%3A%2F%2Fcb.caijiyouxi.com%2Fdy_wechat_login?type=WECHAT_WEB_${envUpper}&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect`;

export const webRtcIceServers = [
  {
    urls: ["stun:stun.chikiigame.com:3478", "stun:stun.l.google.com:19302"],
    // urls: ["stun:stun.caiji188.com:3478", "stun:stun.l.google.com:19302"],
  },
];

// 导航
export let menuAry = [
  {
    name: "首页",
    url: "/index",
    needLogin: false,
  },
  {
    name: "游戏库",
    url: "/gamelibs",
    needLogin: false,
  },
  {
    name: "下载",
    url: "/download",
    needLogin: false,
  },
  {
    name: "耕云计划",
    url: "/plan",
    needLogin: false,
  },
  {
    name: "小卖部",
    url: "/store",
    needLogin: true,
  },
  /* {
    name: 'FAQ',
    url: '/404',
  }, */
];
// pc端跳转，只显示小卖部
if (IS_PC) {
  menuAry = menuAry.slice(-1);
}

// 登录变量
export const loginKeyName = "LOGINKEY";
export const loginAccountIdName = "LOGINACCOUNTID";
export const loginUserInfoName = "LOGINUSERINFO";
export const loginType = "LOGINTYPE";
export const uuid = "UUID";

// 游戏变量
export const currentGameInfo = "CURRENTGAME";
export const currentGameUid = "CURRENTGAMEUID";
export const currentGameNode = "CURRENTGAMENODE";
export const selectGameInfo = "SELECTGAME";
export const gameRunningTime = "GAMERUNNINGTIME";
export const gameNodeInfo = "GAMENODEINFO";
export const isPlayingGame = "ISPLAYINGGAME";
export const isRTCConnected = "ISRTCCONNECTED";
export const isAddTimePlay = "ISADDTIMEPLAY";

export const isWhiteList = () => {
  return true;
};
// 导航qq群数据
export const QQData = {
  qq: "703991278",
  url: "https://qm.qq.com/cgi-bin/qm/qr?k=64-Banbl2KkWgA78ewhCPk7wFJXcI2Yz&authKey=ib2BDkduu76EuQ1Wx2llPEZ84m7tDijg5nuuuwoTG78pRjB5tKGrrf9XHEgGQMvA&noverify=0&group_code=703991278",
};

// 耕耘计划合作游戏类型id
export const cooperationPlanClassifyId = env === "prod" ? 65 : 41;

// 请求头client字段值
export const clientHeader = IS_PC
  ? "pc;pc;;1.0.0;1.0.0.0"
  : "web;web;;1.0.0;1.0.0.0";

// 开始游戏提示充值时长点(s)
export const rechargeTipTime: number = 60 * 5;
// 游戏中提示充值时长(15分钟)
export const rechargeTipTimeInGame: number = 60 * 15;
// 微信支付宝支付回调地址
export const thirdPartyPaymentUrl =
  env === "prod" ? "auth.caiji188.com" : "pre.auth.caiji188.com";

export const gameWindowPageName = "GameWindow";

export const getSpeedCardId = () => {
  // chkii 后台动态配置，queue_card_goods_id
  return isDev ? 10032 : 10059;
};

export const getVipGoodsId = () => {
  // chkii 后台动态配置
  return isDev ? 31000 : 31000;
};
